import type { ComponentProps } from 'react';
import { createRoot } from 'react-dom/client';
import { readPageProps } from '../lib/page-props';
import { InstallPage } from '../pages/InstallPage';

const props = readPageProps<ComponentProps<typeof InstallPage>>();

createRoot(document.getElementById('root')!).render(<InstallPage {...props} />);
